import { createCrudSlice } from "./createCrudSlice";
import {
  ADD_DYNAMIC_PRICES,
  DELETE_DYNAMIC_PRICE,
  GET_DYNAMIC_PRICE_DETAILS,
  GET_DYNAMIC_PRICES,
  UPDATE_DYNAMIC_PRICES,
  UPDATE_DYNAMIC_PRICES_STATUS,
} from "helpers/url_helper";

const { reducer, actions, thunks } = createCrudSlice({
  name: "dynamic prices",

  urls: {
    add: ADD_DYNAMIC_PRICES,
    getList: GET_DYNAMIC_PRICES,
    getDetails: GET_DYNAMIC_PRICE_DETAILS,
    update: UPDATE_DYNAMIC_PRICES,
    delete: DELETE_DYNAMIC_PRICE,
    updateStatus: UPDATE_DYNAMIC_PRICES_STATUS,
  },

  initialFilters: {
    pageNo: 1,
    perPage: 50,
    orderBy: -1,
    status: -1,
    keyword: "",
    planId: "",
    type: "",
    dates: [],
  },

  additionalThunks: {
    
  },

  initialState: {},
});

// Export actions
export const { setFilter, resetFilters, clearItemDetails } = actions;

// Export thunks
export const {
  getList: getDynamicPrices,
  add: addDynamicPrices,
  getDetails: getDynamicPricesDetails,
  update: updateDynamicPrices,
  delete: deleteDynamicPrice,
  updateStatus: updateDynamicPriceStatus,
} = thunks;

// Export reducer
export default reducer;
